export class MicrophoneRecorder {
    dataAvailable: (data: Blob) => void;
    stop_: () => void;
    error: (error: Error) => void;

    private _recorder: any /* MediaRecorder */;

    async start(): Promise<any /* MediaRecorder */> {
        if (this._recorder != null) {
            return;
        }

        if (navigator.mediaDevices.getUserMedia == null) {
            alert('getUserMedia is not supported');
        }

        let stream: MediaStream = null;
        try {
            stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        } catch (err) {
            console.log(err);
            this.error?.(err);
        }
        if (stream == null) {
            return null;
        }

        // eslint-disable-next-line @typescript-eslint/dot-notation
        this._recorder = new window['MediaRecorder'](stream, {
            mimeType: 'audio/webm',
        });
        this._recorder.addEventListener(
            'dataavailable',
            (event: any /* BlobEvent */) => {
                // console.log('mediaRecorder dataavailable');
                this.dataAvailable?.(event.data);
            },
        );
        this._recorder.addEventListener('stop', (event: any) => {
            console.log('mediaRecorder stop');
            this.stop_?.();
        });

        this._recorder.start(1000);
    }

    stop(): void {
        this._recorder?.stop();
        this._recorder = null;
    }
}
